import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const OverflowIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 4" },
        React.createElement("path", { d: "M0 2.06563V1.93436C0 0.81326 0.82632 0 2.00001 0C3.1737 0 4 0.81298 4 1.93436V2.06563C4 3.18672 3.1737 4 2.00001 4C0.82632 4 0 3.18701 0 2.06563Z" }),
        React.createElement("path", { d: "M6 1.93436V2.06563C6 3.18701 6.82632 4 8.00001 4C9.1737 4 10 3.18672 10 2.06563V1.93436C10 0.81298 9.1737 0 8.00001 0C6.82632 0 6 0.81326 6 1.93436Z" }),
        React.createElement("path", { d: "M12 1.93436V2.06563C12 3.18701 12.8263 4 14 4C15.1737 4 16 3.18672 16 2.06563V1.93436C16 0.81298 15.1737 0 14 0C12.8263 0 12 0.81326 12 1.93436Z" })));
};

export { OverflowIcon };
//# sourceMappingURL=OverflowIcon.esm.js.map
